<template>
  <v-container px-0 mx-0>
    <v-snackbar
      v-model="resentSnackbar"
      :timeout="3000"
      top="top"
      color="green lighten-1"
    >
      RE-SENT INVITE
      <v-icon
        color="white"
        v-on:click="resentSnackbar = false"
      >
        close
      </v-icon>
    </v-snackbar>
    <v-dialog v-model="joinCodeDialog" max-width="600">
      <JoinCode/>
    </v-dialog>
    <v-layout justify-center wrap>
      <v-flex xs12>
          <p class="headline my-1">Teacher Accounts</p>
          <p class="body-3 my-3">As the license Administrator you create and manage teacher accounts. Simply paste a list of email addresses and the system does the rest (teachers receive an invite to complete their signup and set a password). Alternatively, you can give teachers your school’s unique Join Code to redeem from the homepage and sign up themselves.</p>
      </v-flex>
      <v-layout justify-center wrap text-xs-center>
        <v-flex xs12 sm6 pa-5 style="background-color: #F5F5F5; border-right:8px white solid;">
          <p class="title text-xs-center">Invite by Email</p>
          <p class="body-3 mb-3 mt-1">Just paste a list of emails. Teachers are sent a link to complete signup and set their password.</p>
          <v-btn
            large
            color="secondary"
            :to="{ path: '/account/invite-teachers' }"
          >
            <v-icon style="margin-right:8px;">email</v-icon>Invite
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 pa-5 style="background-color: #F5F5F5; border-left:8px white solid;">
          <p class="title text-xs-center">Share Join Code</p>
          <p class="body-3 mb-3 mt-1">Give teachers your custom school join code to <br/>sign up themselves.</p>
          <v-btn
            large
            color="secondary"
            @click="displayJoinCode"
          >
            <v-icon style="margin-right:8px;">local_activity</v-icon>Get Code
          </v-btn>
        </v-flex>
      </v-layout>
      <v-flex xs12 py-4>
        <v-dialog v-model="deleteDialog" max-width=300>
          <v-card>
            <v-card-title class="headline">Delete Teacher?</v-card-title>

            <v-card-text>
              Are you sure you want to delete this teacher?
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat v-on:click="deleteDialog = false">Cancel</v-btn>
              <v-btn color="secondary" v-on:click="deletePressed()">Delete</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="editDialog" max-width=700>
          <v-card>
            <v-card-title><span class="headline">Edit Teacher</span></v-card-title>
              <v-card-text>
                <v-container ma-0 pa-0>
                  <form v-on:keyup.enter="updateTeacher()">
                    <v-layout row wrap justify-center>
                      <v-flex xs12 pa-3 v-if="updateError">
                        <v-alert
                          :value="updateError"
                          type="error"
                          outline
                        >
                          {{ updateError }}
                        </v-alert>
                      </v-flex>
                      <v-flex xs12 pa-3>
                        <v-text-field
                          label="Username"
                          v-model="editedItem.username"
                          outline
                          hide-details
                          
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 pa-3>
                        <v-text-field
                          label="First Name"
                          v-model="editedItem.firstname"
                          outline
                          hide-details
                          
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 pa-3>
                        <v-text-field
                          label="Last Name"
                          v-model="editedItem.lastname"
                          outline
                          hide-details
                          
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 pt-2 text-xs-center text-sm-right>
                        <v-btn middle color="secondary" v-on:click="updateTeacher()">Save</v-btn>
                      </v-flex>
                    </v-layout>
                  </form>
                </v-container>
              </v-card-text>
          </v-card>
        </v-dialog>
        <div>
          <div v-if="selected.length > 0">
            <v-toolbar color="highlight" flat dense>
              <v-btn light depressed color="secondary" v-on:click="deleteDialog = true">
                Delete
              </v-btn>
            </v-toolbar>
          </div>
          <div class="headline my-1">Teachers</div>
          <v-data-table
            :headers="headers"
            :loading="loading"
            :items="teachers"
            item-key="username"
            hide-actions
            v-if="teachers"
            select-all
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-if="props.item.id !== $store.getters.user.id"
                  v-model="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
                <div v-else class="font-weight-bold">
                  Admin
                </div>
              </td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.lastname }}</td>
              <td>{{ props.item.firstname }}</td>
              
              <td v-if="props.item.invited">
                Invited
              </td>
              <td v-else>
                Active
              </td>
              
              <td class="layout align-center">
                <v-tooltip top>
                  <div slot="activator" class="item">
                    <v-icon
                      :disabled="props.item.invited"
                      class="mr-2"
                      @click="promptEditTeacher(props.item)"
                    >
                      edit
                    </v-icon>
                  </div>
                  <span>Edit</span>
                </v-tooltip>

                <v-tooltip top>
                  <div slot="activator" class="item">
                    <v-icon
                      class="mr-2"
                      :disabled="props.item.id === $store.getters.user.id"
                      v-on:click="teacherToDelete = props.item; deleteDialog = true;"
                    >
                      delete
                    </v-icon>
                  </div>
                  <span>Delete</span>
                </v-tooltip>
                
                <v-tooltip top>
                  <div slot="activator" class="item">
                    <v-icon
                      v-if="props.item.invited"
                      @click="resendInvitation(props.item)"
                    >
                      email
                    </v-icon>
                  </div>
                  <span>Resend Invitation</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash'
import JoinCode from '@/components/JoinCode'
import TeacherService from '@/services/TeacherService'
import AdministratorService from '@/services/AdministratorService'

export default {
  components: {
    JoinCode
  },
  data: function () {
    return {
      resentSnackbar: false,
      joinCodeDialog: false,
      updateError: null,
      editDialog: false,
      editedIndex: -1,
      editedItem: {
        firstname: '',
        lastname: '',
        username: ''
      },
      deleteDialog: false,
      teacherToDelete: null,
      selected: [],
      headers: [
        {
          text:'Email',
          value:'username'
        },
        {
          text:'Last',
          value:'lastname'
        },
        {
          text:'First',
          value:'firstname'
        },
        {
          text:'Actions',
          sortable: false,
          width: '50'
        },
        {
          text:'Status',
          sortable: false,
          width: '50',
          value: 'status'
        }
      ],
      teachers: [], // will contain psuedo-teachers generated from invitations
      loading: true
    }
  },
  mounted () {
    this.loadTeachers()
  },
  methods: {
    async loadTeachers () {
      try {
        const teachersResponse = await AdministratorService.get()

        const teachers = teachersResponse.data

        const inviteesResponse = await AdministratorService.getInvitedTeachers()

        const processedInvitations = inviteesResponse.data.map(invite => {
          return {
            firstname: null,
            lastname: null,
            username: invite.username,
            invited: true,
            id: invite.id
          }
        })

        this.teachers = teachers.concat(processedInvitations)
        this.loading = false
      } catch (err) {
        console.log(err)
      }
    },
    promptEditTeacher (teacher) {
      this.updateError = null;
      this.editedIndex = this.teachers.indexOf(teacher);
      this.editedItem = Object.assign({}, teacher);
      this.editDialog = true;
    },
    deletePressed () {
      if (this.selected.length > 0) {
        this.deleteTeachers(this.selected);
      } else {
        this.deleteTeacher(this.teacherToDelete);
      }

      this.selected = [];
    },
    async updateTeacher () {
      const teacher = this.editedItem;
      try {
        const result = await TeacherService.put(teacher.id, {
          username: teacher.username,
          firstname: teacher.firstname,
          lastname: teacher.lastname
        });

        this.teachers[this.editedIndex].username = result.data.username;
        this.teachers[this.editedIndex].firstname = result.data.firstname;
        this.teachers[this.editedIndex].lastname = result.data.lastname;

        this.editedIndex = -1;
        this.editedItem = {
          firstname: '',
          lastname: '',
          username: ''
        };
        this.editDialog = false;
        this.updateError = null;
      } catch (err) {
        this.updateError = err.response.data.error;
      }
    },
    async deleteTeacher (teacher) {
      if (teacher.invited) {
        try {
          // teacher.id is the invite id. it is set on loadTeachers so both invites and teachers can reside in the same table
          await AdministratorService.deleteInvitation(teacher.id)

          this.teacherToDelete = null;
          this.deleteDialog = false;

          this.teachers = _.filter(this.teachers, ins => {
            return ins.id !== teacher.id;
          })

          return teacher;
        } catch (err) {
          return err;
        }
      } else if (teacher.id !== this.$store.getters.user.id) {
        try {
          await TeacherService.delete(teacher.id);

          this.teacherToDelete = null;
          this.deleteDialog = false;

          this.teachers = _.filter(this.teachers, ins => {
            return ins.id !== teacher.id;
          })

          return teacher;
        } catch (err) {
          console.log(err);
        }
      } else {}
      
    },
    async deleteTeachers (teachers) {
      const requests = [];
      
      for (let i = 0; i < teachers.length; i++) {
        var teacher = teachers[i];
        if (teacher.invited) {
          const invitation = teacher;
          try {
            await AdministratorService.deleteInvitation(invitation.id)

            requests.push(invitation);
          } catch (err) {
            console.log(err);
          }
        } else {
          try {
            await TeacherService.delete(teacher.id);

            requests.push(teacher);
          } catch (err) {
            console.log(err);
          }
        }
      }

      this.deleteDialog = false;
      
      this.loadTeachers();
    },
    displayJoinCode () {
      this.joinCodeDialog = true
    },
    async resendInvitation (invite) {
      try {
        await TeacherService.invite({username: invite.username});
        
        this.resentSnackbar = true
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
</style>
